import { useLocation } from "react-router-dom";
import { useSiteSettings } from "@/hooks/useSiteSettings";

/**
 * Floating WhatsApp button shown on every public page.
 * The number is configured by the admin in Site Settings (social.whatsapp)
 * and stored in the database. It is hidden on the admin dashboard.
 */
export default function WhatsAppButton() {
  const { social } = useSiteSettings();
  const { pathname } = useLocation();

  // Don't show the chat button inside the admin dashboard.
  if (pathname.startsWith("/admin")) return null;

  // Admin can hide the button entirely via the settings toggle.
  if (social.whatsapp_enabled === false) return null;

  const raw = (social.whatsapp || "").trim();
  if (!raw) return null;

  const digits = raw.replace(/[^\d]/g, "");
  if (!digits) return null;

  return (
    <a
      href={`https://wa.me/${digits}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-3"
    >
      <span className="pointer-events-none hidden rounded-full bg-brand-dark px-4 py-2 text-sm font-medium text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100 md:block whitespace-nowrap">
        Chat on WhatsApp
      </span>
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white transition-transform duration-200 group-hover:scale-110">
        <i className="fa-brands fa-whatsapp text-3xl"></i>
      </span>
    </a>
  );
}